<!-- results-table.component.html -->
<h1 mat-dialog-title>Asociación de objetivo / riesgo, análisis inherente</h1>
<div mat-dialog-content>

  <div class="content p-24">

      <div fxLayout="row" xFlex="100">

          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">

              <div class="profile-box info-box general" fxLayout="column">

                <table class="summary">
                    <tr>
                        <td class="label">Escenario</td>
                        <td class="value">{{escenario.nombre}}</td>
                    </tr>

                    <tr>
                        <td class="label">Objetivo</td>
                        <td class="value">{{objetivoRiesgo.objetivo.nombre}}</td>
                    </tr>

                </table>
              </div>
          </div>


          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">
            <div class="profile-box info-box general" fxLayout="column">
              <table class="summary">
                <tr>
                    <td class="label">Riesgo</td>
                    <td class="value">{{objetivoRiesgo.riesgo.nombre}}</td>
                </tr>

                <tr>
                  <td class="label">Probabilidad inherente</td>
                  <td class="value">
                    <mat-form-field fxFlex>
                      <mat-label>Probabilidad</mat-label>
                      <mat-select [(ngModel)]="probabilidad" class="roleSelect" (selectionChange)="probabilidadChange()">
                          <mat-option *ngFor="let probabilidad of escenario.probabilidades" [value]="probabilidad">
                              {{probabilidad.nombre}} ({{probabilidad.valor | number:'1.2-2'}})
                          </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                </tr>

              </table>
          </div>
      </div>
    </div>
  </div>


          <!-- CONTENT CARD -->
          <div class="content-card">

            <mat-tab-group animationDuration="0ms">
              <mat-tab label="Líneas">

                  <!-- CONTENT -->

                  <div class="content p-10" fxLayout="row" fxFlex>
                    <!--
                    <div style="margin-right:10px;" fxFlex>
                      <mat-form-field fxFlex>
                        <mat-label>Dimensión</mat-label>
                        <mat-select [(ngModel)]="new_line_p.dimension" class="roleSelect">
                            <mat-option *ngFor="let dimension of dimensiones" [value]="dimension">
                                {{dimension.nombre}}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>-->
                    <div style="margin-right:10px;" fxFlex>
                      <mat-form-field fxFlex>
                      <mat-label>Categoría</mat-label>
                      <mat-select [(ngModel)]="new_line_p.categoria" class="roleSelect">
                          <mat-option *ngFor="let categoria of categorias" [value]="categoria">
                              {{categoria}}
                          </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="margin-right:10px;" fxFlex>
                    <mat-form-field fxFlex>
                      <mat-label>Impacto</mat-label>
                      <mat-select [(ngModel)]="new_line_p.impacto" class="roleSelect">
                          <mat-option *ngFor="let impacto of escenario.impactos" [value]="impacto">
                              {{impacto.nombre}} ({{impacto.valor | number:'1.2-2'}})
                          </mat-option>
                      </mat-select>
                    </mat-form-field></div>
                    <div style="margin-right:10px;">
                      <button mat-button (click)="addLine()" mat-flat-button color="primary" class="add-row">Agregar</button>
                    </div>

                    </div>
                    <div class="content p-24">
                      <table mat-table [dataSource]="objetivoRiesgo.analisisInherente" #tableProbabilidad class="my-table mat-elevation-z8 select-list" >

                        <ng-container matColumnDef="probabilidad">
                          <th mat-header-cell *matHeaderCellDef> Probabilidad </th>
                          <td mat-cell *matCellDef="let element">
                            <span matTooltip="{{element.probabilidad?.nombre}}"
                            matTooltipPosition="right">{{element.probabilidad.valor | number:'1.2-2'}}
                            </span>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="impacto">
                          <th mat-header-cell *matHeaderCellDef> Impacto inherente </th>
                          <td mat-cell *matCellDef="let element"> 
                            <span matTooltip="{{element.probabilidad?.nombre}}"
                            matTooltipPosition="right">{{element.impacto.valor | number:'1.2-2'}}
                            </span>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="exposicion">
                          <th mat-header-cell *matHeaderCellDef> Exposición </th>
                          <td mat-cell *matCellDef="let element"> {{element.exposicion | number:'1.2-2'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="descripcion">
                          <th mat-header-cell *matHeaderCellDef> Dimensión </th>
                          <td mat-cell *matCellDef="let element"> {{element.dimension?.nombre}} </td>
                        </ng-container>

                        <ng-container matColumnDef="categoria">
                          <th mat-header-cell *matHeaderCellDef> Categorías </th>
                          <td mat-cell *matCellDef="let element"> {{element.categoria}} </td>
                        </ng-container>


                        <ng-container matColumnDef="clasificacion">
                          <th mat-header-cell *matHeaderCellDef> Clasificación </th>
                          <td mat-cell *matCellDef="let element"> {{element.clasificacion}} </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Acción </th>
                          <td mat-cell *matCellDef="let element; let i = index;" class="action-link">
                            <a (click)="edit(element,i)">Editar</a> |
                            <a (click)="remove(element,i)">Eliminar</a>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      </table>

                  </div>

                  <!-- / CONTENT -->
                </mat-tab>

            </mat-tab-group>

          </div>
          <!-- / CONTENT CARD -->



</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">Modificar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
</div>
